import React, { Component } from 'react';
import { connect } from 'react-redux';
import store from './reducers/store';
import userService from './services/userService';
import positionsService from './services/positionsService';
import statusService from './services/statusService';
import conferenceService from './services/conferenceService';
import locationService from './services/locationService';
import playersService from './services/playersService';

import './combinedStyles';

class App extends Component {
  constructor(props) {
    super(props);
  }

  async componentWillMount() {
    const currentLocation = this.props.location.pathname;

    if (currentLocation.indexOf('/redirect') > -1 && (await userService.isLoggedIn()) !== false) {
      await this.setUpPage();

      this.props.history.push('/dashboard');
    } else if ((await userService.isLoggedIn()) !== false) {
      await this.setUpPage();
    } else {
      this.props.history.push('/login');
    }
  }

  async setUpPage() {
    const currentLocation = this.props.location.pathname;

    if (
      !this.props.positions ||
      !this.props.conferences ||
      !this.props.states ||
      !this.props.status
    ) {
      await positionsService.get();
      await conferenceService.getConferences();
      await locationService.getStates();
      await statusService.getStatuses();
    }

    if (!this.props.displayedUser || !this.props.organization) {
      const user = await userService.getUser(
        JSON.parse(window.localStorage.getItem('access_token')).payload.sub
      );

      store.dispatch({ type: 'UPDATE_FILTERS', filters: user.filters });
      store.dispatch({ type: 'UPDATE_ACTIVE_USER', activeUser: user });
      store.dispatch({ type: 'UPDATE_DISPLAYED_USER', displayedUser: user });

      store.dispatch({ type: 'UPDATE_ACTIVE_USER', activeUser: user });

      if (!this.props.organization) {
        store.dispatch({ type: 'UPDATE_ORG', organization: user.organization });
      }

      if (user.organization.package.is_zmail && typeof user.filters !== 'undefined') {
        const trackedProspectFilters = user.filters.filter(
          (f) => f.filterCategory.name === 'trackedProspect'
        );
        if (
          trackedProspectFilters.length > 0 &&
          typeof trackedProspectFilters[0].filterValues !== 'undefined'
        ) {
          playersService.getTrackedPlayers(
            user.filters
              .filter((f) => f.filterCategory.name === 'trackedProspect')[0]
              .filterValues.map((value) => {
                return value.value;
              })
          );
        }
      }

      if (user.super_user) {
        userService.getUsersFromOrg(window.localStorage.getItem('organization_id'));
      }
    }

    if (currentLocation === '/login' || currentLocation === '/') {
      this.props.history.push('/dashboard');
    }
  }

  render() {
    return <div className='App' />;
  }
}

function mapStoreToProps(storeState) {
  return {
    loadedCredentials: storeState.main.loadedCredentials,
    loadedLists: storeState.lists.loadedLists,
    POIList: storeState.lists.POIList,
    allPlayers: storeState.lists.allPlayers,
    loadingPlayersBool: storeState.main.loadingPlayers,
    finishedLoadingPlayersBool: storeState.main.finishedLoadingPlayers,
    loggedIn: storeState.main.loggedIn,
    redirected: storeState.main.redirected,
    displayedUser: storeState.main.displayedUser,
    activeUser: storeState.main.activeUser,
  };
}

export default connect(mapStoreToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js